import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient, HttpEvent, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../_model/ApiResponse';
import { OvertimeRequest } from '../_model/request/OvertimeRequest';
import { OvertimeSearchRequest } from '../_model/request/OvertimeSearchRequest';
import { HrAdminOvertimeRequest } from '../_model/request/HrAdminOvertimeRequest';
import { OvertimeRejectRequest } from '../_model/overtime';
import { OvertimeDeservedRequest } from '../_model/request/OvertimeDeservedRequest';
import { OvertimeReportPeriodsRequest } from '../_model/request/OvertimeReportPeriodsRequest';
import { OvertimeReportRequest } from '../_model/request/OvertimeReportRequest';

@Injectable({
  providedIn: 'root',
})
export class OvertimeService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }
  rejectOvertime(request: OvertimeRejectRequest): Observable<ApiResponse> {
    return this.put<ApiResponse>('/api/v1/overtimes/reject', request);
  }
  approveOvertime(request): Observable<ApiResponse> {
    return this.put<ApiResponse>('/api/v1/wf/approvals', request);
  }

  saveOvertime(overtimeRequest: OvertimeRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/overtimes', overtimeRequest);
  }

  updateOvertime(overtimeRequest: OvertimeRequest): Observable<ApiResponse> {
    return this.put<ApiResponse>('/api/v1/overtimes', overtimeRequest);
  }

  updateOvertimeByAdmin(overtimeRequest: HrAdminOvertimeRequest): Observable<ApiResponse> {
    return this.put<ApiResponse>('/api/v1/overtimes/admin', overtimeRequest);
  }

  listOvertimes(overtimeSearchRequest: OvertimeSearchRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/overtimes/all', overtimeSearchRequest);
  }

  listOvertimeApproveds(overtimeSearchRequest: OvertimeSearchRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/overtimes/approveds', overtimeSearchRequest);
  }

  listMyOvertimeRequests(overtimeSearchRequest: OvertimeSearchRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/overtimes/myrequests', overtimeSearchRequest);
  }

  listOvertimeRejecteds(overtimeSearchRequest: OvertimeSearchRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/overtimes/rejecteds', overtimeSearchRequest);
  }

  listOvertimeWaitings(overtimeSearchRequest: OvertimeSearchRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/overtimes/waitingforapprovals', overtimeSearchRequest);
  }

  uploadOvertimeFile(formData: FormData, recordId: number): Observable<HttpEvent<ApiResponse>> {
    return this.upload<ApiResponse>('/api/v1/overtimes/uploadfile/' + recordId, formData);
  }

  deleteOvertime(id: number): Observable<ApiResponse> {
    return this.delete<ApiResponse>('/api/v1/overtimes/' + id);
  }

  getOvertimeDeserved(overtimeDeservedRequest: OvertimeDeservedRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/overtimes/getOvertimeDeserved', overtimeDeservedRequest);
  }

  getDepartmentList(): Observable<ApiResponse> {
    return this.get<ApiResponse>('/api/v1/overtimes/departments');
  }

  getEmployeeList(departmentId: number): Observable<ApiResponse> {
    return this.get<ApiResponse>('/api/v1/overtimes/employees?departmentId=' + departmentId);
  }

  getReportPeriods(overtimeReportPeriodsRequest: OvertimeReportPeriodsRequest): Observable<ApiResponse> {

    return this.post<ApiResponse>('/api/v1/overtimes/report', overtimeReportPeriodsRequest);
  }

  getReportData(overtimeReportRequest: OvertimeReportRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/overtimes/reportExcel', overtimeReportRequest);
  }

  sendErp(request: { departmentId?: number; employeeId?: number; period: string }): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/overtimes/sendErp', request);
  }
}